<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag" [dragula]='"widget-bag"'>
  <swb-news></swb-news>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag" [dragula]='"widget-bag"'>
  <swb-articles></swb-articles>
  <swb-categories></swb-categories>
</div>